((global) => {

  /**
  * Боковая панель проводника.
  *
  * @class WebAccess.components.SidePanel
  * @extends BaseObject
  * @since 5.8.3.9000
  */
  class SidePanel extends BaseObject {
    constructor() {
      super();
      this.headerString = '';
    };

    /**
     * Отображает боковую панель.
	   * @function WebAccess.components.SidePanel.render
     * */
    render() {
      let innerHtml = `<div id="sidepanel-header">
          <div style="float: left; padding-top: 4px;">
            <span>${this.headerString}</span>
          </div>
          <div class="tool-button" title="${L('CLOSE')}" onClick="WA.CMP.SidePanel.prototype.toggleActive(false)">
            <svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-delete-16"></use></svg>
          </div>
        </div>
        <div id="sidepanel-body"></div>`;
      this.html = `<div class="sidepanel">${innerHtml}</div>`;
      let panelElement = $('.sidepanel');
      if (panelElement.length) {
        // Очищается ИД панели, чтобы не срабатывали ложные события.
        if (panelElement.attr('id')) {
          panelElement.removeAttr('id');
        }
        panelElement.html(innerHtml);
      } else {
        let form = $('form');
        if (form) {
          form.prepend(this.html);
          $(document).click(e => { this.closePanel(e) })
            .contextmenu(e => { this.closePanel(e) })
            .bind('openFolderContextMenu', () => { this.closePanel(e) });
        }
      }
      return this;
    };

    /**
     * Закрывает боковую панель.
     * @function WebAccess.components.SidePanel.closePanel
     * @param {} event Событие клика.
     * */
    closePanel(event) {
      if ($('.sidepanel').hasClass('active') &&
        !event.target.closest('.sidepanel') &&
        (!event.target.closest('.base-header__explorer-additional-btn') ||
          (event.target.closest('.base-header__explorer-additional-btn') && !event.target.closest('.base-header__explorer-additional-btn').classList.contains('active'))) &&
        !event.target.closest('[class^="ui-"]') &&
        !event.target.closest('.toast')) {
        event.stopPropagation();
        event.preventDefault();
        this.toggleActive(false);
      }
    };

    /**
     * Скрывает или показывает панель уведомлений.
	   * @function WebAccess.components.SidePanel.toggleActive
     * @param {any} isActive Признак, показана или скрыта панель уведомлений в данный момент
     */
    toggleActive(isActive) {
      let panelElement = $('.sidepanel');
      if (panelElement.length) {
        if (isActive) {
          panelElement[0].classList.add('active');
          panelElement.focus();
        } else {
          panelElement[0].classList.remove('active');

          let event = document.createEvent('CustomEvent');
          event.initCustomEvent('hideSidePanel', true, false, '');
          document.dispatchEvent(event);
        }
      }
    };
  }

  global.SidePanel = SidePanel;
})(window.WebAccess.components);